export default __webpack_public_path__ + "11a87538ac0ad6f1eb5996a6fbeb3849.png";